<template>
  <v-card>
   <v-toolbar color="blue-grey white--text">
      <v-toolbar-title class="white--text">สรุปจำนวนนักศึกษา</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title class="subheading white--text"></v-toolbar-title>
    </v-toolbar> 

    <v-card-text>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 md6 d-flex>
            <v-select
              :loading="loadingAcademicYear"
              :items="academicYearItems"
              label="ปี/ภาคการศึกษา"
              v-model="params.academicYear"
              item-value="id"
              item-text="yearSemester"
              outline
              hide-details
              @change="active = true"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm12 md4 offset-md1>
            <v-radio-group v-model="printType" row :disabled="!active">
              <v-radio label="รายวิชา" value="A"></v-radio>
              <v-radio label="ภาค/สาขาวิชา" value="B"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-slide-x-transition mode="out-in">
        <v-btn
          color="info"
          target="_new" 
          :href="printoutUrl"
          v-if="active"
        >
          <v-icon left dark>cloud_download</v-icon> ส่งออกข้อมูล
        </v-btn>
      </v-slide-x-transition>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config/index'
import swal from 'sweetalert2'
import moment from 'moment'

export default {
  data () {
    return {
      active: false,
      disabled: true,
      loading: false,
      loadingAcademicYear: false,
      academicYearItems: [],
      params: {
        academicYear: null
      },
      printType: 'A'
    }
  },
  mounted () {},
  computed: {
    ...mapGetters ({
      token: 'token'
    }),
    printoutUrl () {
      let printoutUrl
      if(this.printType === 'A') {
        printoutUrl = `${config.serverURI}/reports/printout/aggregateStudentBySubject?academicYear=${this.params.academicYear}&access_token=${this.token}`
      }
      if(this.printType === 'B') {
        printoutUrl = `${config.serverURI}/reports/printout/aggregateStudentByDepartment?academicYear=${this.params.academicYear}&access_token=${this.token}`
      }
      return printoutUrl
    }
  },
  mounted () {
    this.fetchAcademicYears ()
  },
  methods: {
    date (val) {
      return val ? this.$options.filters.formatFullDate(val) : null
    },
    fetchAcademicYears () {
      this.loadingAcademicYear = true
      this.$store.dispatch("academicYear/loadItems")
        .then((response) => {
          this.academicYearItems = response.data
          this.loadingAcademicYear = false
        }).catch((error)=>{
          console.log('reload', error)
          this.loadingAcademicYear = false
        })
    }
  },
  watch: {
    'params': {
      handler (val) {
       
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .boxes {
    min-width: 400px;
  }
</style>


// WEBPACK FOOTER //
// src/components/reports/aggregateStudent/index.vue